import { Cookies } from 'react-cookie'

export const getCookiesFromContext = ({ req }: ExtendedNextPageContext) => {
  return req?.universalCookies || new Cookies()
}

export default getCookiesFromContext
